(() => {
  if (document.querySelector('#MainContent')?.dataset.template !== 'index' || window.Shopify?.designMode) return;
  const popup = document.querySelector('[data-newsletter-popup]');
  const tab = document.querySelector('[data-newsletter-reopen]');
  if (!popup || !tab || typeof popup.showModal !== 'function') return;
  const key = 'annarita-newsletter-home-v2';
  let previousFocus;
  let timer;
  const read = () => { try { return window.sessionStorage.getItem(key); } catch { return null; } };
  const write = (value) => { try { window.sessionStorage.setItem(key, value); } catch {} };
  const success = document.querySelector('[data-newsletter-success]');
  const completed = Boolean(success) || read() === 'completed';
  const show = () => {
    if (popup.open) return;
    previousFocus = document.activeElement;
    tab.hidden = true;
    popup.showModal();
    if (!completed) write('shown');
  };
  const close = () => popup.close();
  popup.querySelector('[data-newsletter-close]')?.addEventListener('click', close);
  popup.addEventListener('close', () => {
    tab.hidden = completed;
    if (!completed) write('dismissed');
    if (previousFocus && previousFocus !== document.body && previousFocus.isConnected) previousFocus.focus();
    else if (!completed) tab.focus();
  });
  popup.addEventListener('click', (event) => {
    if (event.target !== popup) return;
    const rect = popup.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
  });
  tab.addEventListener('click', show);
  if (success) {
    write('completed');
    if (popup.querySelector('[data-newsletter-success]')) show();
    return;
  }
  const popupError = popup.querySelector('[data-newsletter-error]');
  if (popupError) {
    show();
    popupError.focus();
    return;
  }
  if (completed) return;
  if (read()) {
    tab.hidden = false;
    return;
  }
  let ready = false;
  const maybeShow = () => {
    if (!ready || popup.open || read()) return;
    if (document.hidden) return;
    if (document.querySelector('dialog[open], details[open].menu-drawer-container, cart-drawer.active')) {
      timer = window.setTimeout(maybeShow, 500);
      return;
    }
    show();
  };
  document.addEventListener('visibilitychange', maybeShow);
  timer = window.setTimeout(() => { ready = true; maybeShow(); }, 5000);
  window.addEventListener('pagehide', () => window.clearTimeout(timer), { once: true });
})();
